<template>
  <form class="page-form" @submit.prevent="submit">
    <Field
      label="Page name"
      placeholder="e.g. About Us"
      @input="$v.resource.name.$touch()"
      @handleChange="handleChange"
      v-model="resource.name"
      helpText="If the <strong>Show In Menu</strong> setting is enabled, the name of the page will be used in your site menus"
      :error="nameError"/>

    <div v-if="isHomePage" class="input is-home-page">
      <div class="field-label">
      <label>Page Path</label>
      </div>
      <input disabled value="Home page path cannot be changed">
    </div>

    <Field
      label="Page path"
      v-else
      :preText="`${websiteUrl}/`"
      @input="$v.resource.path.$touch()"
      @handleChange="handleChange"
      v-model="path"
      helpText="e.g. '<strong>our-company/team/join-us</strong>'"
      placeholder="about-us"
      :error="pathError"/>

    <Field
      label="Show in Menu?"
      type="checkbox"
      @input="$v.resource.show_in_menu.$touch()"
      @handleChange="handleChange"
      v-model="resource.show_in_menu"
      helpText="Should this page be accessible by your site menu and footer?"/>

     <Field
      label="Page Password"
      @input="$v.resource.password_protect.$touch()"
      @handleChange="handleChange"
      v-model="resource.password_protect"
      helpText="Setting a password will require users to enter it when accessing this page."
      :error="password_protectError"/>

    <hr>

    <PageHeader>
      <div class="heading">
        <h1>
          Page SEO
        </h1>
      </div>
    </PageHeader>

    <Field
      label="Page Title"
      @input="$v.resource.title.$touch()"
      @handleChange="handleChange"
      v-model="resource.title"
      helpText="Page titles are displayed on search engine results pages and should be an accurate and concise description of a page's content"
      :error="titleError"/>

    <Field
      label="Page Description"
      @input="$v.resource.description.$touch()"
      @handleChange="handleChange"
      v-model="resource.description"
      helpText="Search engines sometimes use these snippets in search results to let visitors know what a page is about before they click on it"
      :error="descriptionError"/>

    <Field
      label="Preview Image URL"
      @input="$v.resource.preview_image.$touch()"
      @handleChange="handleChange"
      v-model="resource.preview_image"
      helpText="When sharing this page on (e.g. on social media), this image image will appear in the preview "
      :error="preview_imageError"/>

    <div class="btn-save">
      <btn :class="{'changes-made': changesMade}">Save Changes</btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'
import PageHeader from '@/components/PageHeader'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'PageForm',

  data() {
    return {
      sitePath: ''
    }
  },

  mixins: [form],

  props: {
    websiteUrl: String,
    isHomePage: Boolean
  },

  computed: {
    ...errorMessages([
      'menu_weight',
      'show_in_menu',
      'password_protect',
      'preview_image',
      'title',
      'description',
      'name',
      'path'
    ]),

    path: {
      get() {
        let path = this.resource.path

        if (path && path.charAt(0) === '/') {
          path = path.substring(1)
        }

        return path
      },

      set(pageName) {
        let path = pageName.replace(/\s+/g, '-').toLowerCase()
        this.resource.path = '/' + path
      }
    }
  },

  components: {
    Btn,
    PageHeader
  },

  validations: {
    resource: {
      menu_weight: {},
      show_in_menu: {},
      preview_image: {},
      password_protect: {},
      title: {},
      description: {},
      name: {required},
      path: {required}
    }
  }
}
</script>

<style lang="sass" scoped>
.is-home-page
  input
    color: rgba(0, 0, 0, 0.25)
</style>
